module.exports = __webpack_public_path__ + "media/images/front/top/750x200-8600438b3fc53d41069009b02d509c18.png";